import React, { useEffect, useMemo } from 'react';

import { OpenFeature } from '@openfeature/react-sdk';
import { useSelector } from 'react-redux';

import { Store } from 'types/store/Store';

import { buildFeatureFlagContext } from './buildFeatureFlagContext';

const OpenFeatureUserContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const userProfile = useSelector(
    (state: Store) => state.getUserById.data?.data?.profile,
  );
  const companyId = useSelector(
    (state: Store) => state.getUserById.data?.data?.companyId,
  );
  const authToken = useSelector((state: Store) => state.auth.token);

  const contextData = useMemo(() => {
    if (!authToken) {
      return buildFeatureFlagContext({});
    }

    if (userProfile?.user_id) {
      return buildFeatureFlagContext({
        userId: userProfile.user_id,
        email: userProfile.email,
        companyId,
      });
    }

    return null;
  }, [userProfile?.user_id, userProfile?.email, companyId, authToken]);

  useEffect(() => {
    const updateOpenFeatureContext = async () => {
      if (contextData) {
        try {
          await OpenFeature.setContext(contextData);
        } catch (error) {
          console.error('Failed to set OpenFeature context:', error);
        }
      }
    };

    updateOpenFeatureContext();
  }, [contextData]);

  return <>{children}</>;
};

export default OpenFeatureUserContextProvider;
